// extracted by mini-css-extract-plugin
export var container = "ResponseExample2024-module--container--974ac";